import { Component } from '@angular/core';

@Component({
  selector: 'empty',
  template: '<div></div>',
  standalone: false,
})
export class EmptyComponent {}
